import React from "react";
// import {useRef} from "react";
import "./SnookerGame.scss";
import { startup } from "./ThreeIndex";


export class SnookerGame extends React.Component<any, any> {
    // set by the ref callback below before componentDidMount runs
    mount: HTMLElement | null = null;

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        console.log("SnookerGame Mounted");
        if (this.mount) startup(this.mount);
    }

    componentWillUnmount() {
        console.log("SnookerGame Unmounting");
        // this.mount.innerHTML = "";
    }

    render() {
        // #game-placeholder is the fullscreen target; the canvas lives in #game-canvas-host and the
        // HUD/overlays (children) sit on top of it, so they stay visible in fullscreen.
        return <div id="game-placeholder">
            <div id="game-canvas-host" ref={(mount) => { if (mount) this.mount = mount }}></div>
            {this.props.children}
        </div>
    }
}